import { Injectable, } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PodcastApiService } from '../api/podcasts.service';

@Injectable({ providedIn: 'root' })
export class PodcastDetailsResolver implements Resolve<any> {
  constructor(
    private apiService: PodcastApiService,
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const podcastId = route.paramMap.get('id');
    if (podcastId) {
      return this.apiService.getPodcastDetails(podcastId);
    }
    return of(null);
  }
}